/**
 * Created by Julio Perez on 9/1/2016.
 */

import routing from './app-view.routes';

import AppViewController from './app-view.controller';
import appView from  './app-view.directive';

export default angular
    .module('app.appView', [appView])
    .config(routing)
    .controller('AppViewController', AppViewController)
    .name;


// WEBPACK FOOTER //
// ./src/app/app-view/index.js